var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyStateProcessingActivities = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 260,
    viewBox: "0 0 400 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.746 45.2183H85.7617L192.746 140.757H85.7617",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.418 47.8501C156.867 38.8989 150.805 30.4647 141.877 29.0117C132.95 27.5588 124.538 33.6372 123.089 42.5884C121.64 51.5396 127.702 59.9738 136.63 61.4267C145.557 62.8797 153.969 56.8012 155.418 47.8501Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M208.915 47.8452C210.364 38.8941 204.302 30.4598 195.374 29.0069C186.447 27.5539 178.035 33.6324 176.586 42.5835C175.137 51.5347 181.199 59.9689 190.127 61.4219C199.054 62.8748 207.466 56.7964 208.915 47.8452Z",
    fill: "#4767FF",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.926 47.8486C103.376 38.8975 97.3132 30.4633 88.3856 29.0103C79.4581 27.5573 71.0462 33.6358 69.597 42.5869C68.1479 51.5381 74.2103 59.9723 83.1378 61.4253C92.0654 62.8783 100.477 56.7998 101.926 47.8486Z",
    fill: "#4767FF",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M208.915 95.6206C210.364 86.6695 204.302 78.2352 195.374 76.7823C186.447 75.3293 178.035 81.4078 176.586 90.3589C175.137 99.3101 181.199 107.744 190.127 109.197C199.054 110.65 207.466 104.572 208.915 95.6206Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.926 95.6172C103.376 86.666 97.3132 78.2318 88.3856 76.7788C79.4581 75.3259 71.0462 81.4043 69.597 90.3555C68.1479 99.3066 74.2103 107.741 83.1378 109.194C92.0654 110.647 100.477 104.568 101.926 95.6172Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M155.418 95.6186C156.867 86.6675 150.805 78.2333 141.877 76.7803C132.95 75.3273 124.538 81.4058 123.089 90.357C121.64 99.3081 127.702 107.742 136.63 109.195C145.557 110.648 153.969 104.57 155.418 95.6186Z",
    fill: "#4767FF",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145.518 155.92C153.874 152.449 157.842 142.845 154.381 134.466C150.92 126.088 141.34 122.11 132.984 125.58C124.628 129.051 120.66 138.656 124.121 147.034C127.583 155.412 137.162 159.39 145.518 155.92Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0249 155.922C100.381 152.451 104.349 142.846 100.888 134.468C97.4265 126.09 87.8469 122.112 79.491 125.582C71.1351 129.052 67.1671 138.657 70.6283 147.035C74.0894 155.414 83.669 159.392 92.0249 155.922Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M199.011 155.918C207.367 152.448 211.335 142.843 207.874 134.465C204.413 126.087 194.833 122.108 186.477 125.578C178.121 129.049 174.153 138.654 177.615 147.032C181.076 155.41 190.655 159.388 199.011 155.918Z",
    fill: "#4767FF",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M192.924 98.4489C195.932 98.4489 198.37 96.0042 198.37 92.9886C198.37 89.973 195.932 87.5283 192.924 87.5283C189.917 87.5283 187.479 89.973 187.479 92.9886C187.479 96.0042 189.917 98.4489 192.924 98.4489Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9908 146.024C88.9985 146.024 91.4367 143.579 91.4367 140.564C91.4367 137.548 88.9985 135.104 85.9908 135.104C82.9831 135.104 80.5449 137.548 80.5449 140.564C80.5449 143.579 82.9831 146.024 85.9908 146.024Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7617 96.5218C87.6374 96.5218 89.1581 94.9971 89.1581 93.1164C89.1581 91.2356 87.6374 89.7109 85.7617 89.7109C83.8859 89.7109 82.3652 91.2356 82.3652 93.1164C82.3652 94.9971 83.8859 96.5218 85.7617 96.5218Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8145 227.964C85.1143 226.694 84.3276 225.422 83.0574 225.122C81.7872 224.822 80.5145 225.609 80.2147 226.879C79.9149 228.149 80.7016 229.422 81.9718 229.722C83.242 230.021 84.5147 229.235 84.8145 227.964Z",
    fill: "#071A24"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M285.057 77.3639C285.356 76.0937 284.57 74.8209 283.3 74.5211C282.029 74.2213 280.757 75.008 280.457 76.2782C280.157 77.5484 280.944 78.8212 282.214 79.1209C283.484 79.4207 284.757 78.6341 285.057 77.3639Z",
    fill: "#071A24"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M322.697 47.2804C317.703 48.5223 316.508 50.0601 315.661 57.1054C315.611 57.5158 315.032 57.5158 314.982 57.1054C314.137 50.0579 312.94 48.5223 307.946 47.2804C307.596 47.194 307.596 46.6821 307.946 46.5957C312.94 45.3538 314.135 43.816 314.982 36.7707C315.032 36.3603 315.611 36.3603 315.661 36.7707C316.506 43.8182 317.703 45.3538 322.697 46.5957C323.047 46.6821 323.047 47.194 322.697 47.2804Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M206.012 182.077C213.243 188.184 222.153 191.003 230.926 190.676C238.992 190.38 246.945 187.419 253.348 181.912C254.81 180.662 256.19 179.274 257.472 177.756C258.919 176.041 260.184 174.235 261.261 172.355C269.887 157.345 266.836 137.864 253.147 126.3C237.747 113.281 214.706 115.217 201.691 130.621C199.215 133.555 197.279 136.764 195.875 140.127C189.902 154.431 193.541 171.538 206.012 182.077V182.077Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M212.052 174.932C217.524 179.557 224.294 181.642 230.925 181.311C238.176 180.952 245.269 177.7 250.323 171.715C260.007 160.261 258.567 143.126 247.11 133.443C235.653 123.764 218.518 125.203 208.835 136.657C207.896 137.764 207.064 138.924 206.339 140.126C199.526 151.359 201.702 166.187 212.052 174.932Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M253.348 181.912L265.499 192.178C266.587 193.097 268.224 192.959 269.142 191.871L273.814 186.343C274.733 185.255 274.595 183.619 273.507 182.7L261.261 172.351L253.348 181.912Z",
    fill: "#071A24"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M314.968 227.217L316.308 225.632C316.911 224.918 316.821 223.838 316.107 223.231L268.614 183.098C267.9 182.495 266.82 182.586 266.213 183.299L264.872 184.884C264.269 185.598 264.36 186.678 265.073 187.285L312.567 227.418C313.28 228.021 314.361 227.93 314.968 227.217V227.217Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M334.684 189.335C334.684 189.335 279.491 167.946 266.097 206.478C254.53 239.762 284.06 238.418 283.027 223.846C282.247 212.826 266.097 199.799 253.347 203.139C238.412 207.05 238.94 220.506 246.065 220.727C254.742 220.999 253.035 206.486 246.731 192.789",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M249.475 95.7402L243.486 112.828",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M261.39 101.417L252.097 116.956",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M273.02 110.068L260.052 122.704",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M139.538 218.171C139.538 212.545 143.587 208.5 149.209 208.5C143.583 208.5 139.538 204.45 139.538 198.828C139.538 204.454 135.488 208.5 129.866 208.5C135.492 208.5 139.538 212.549 139.538 218.171Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M250.192 62.9958C250.768 60.5565 249.257 58.1118 246.818 57.5356C244.378 56.9595 241.933 58.4704 241.358 60.9108C240.782 63.3502 242.293 65.7949 244.732 66.3711C247.173 66.9462 249.617 65.4352 250.192 62.9958Z",
    fill: "#071A24"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyStateProcessingActivities);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EmptyStateProcessingActivities.eca890230dd2a3f620ac14816010e308.svg";